export class ListMyMPARequestsRequestFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "MPARequestStatus",
            "format": ""
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "MPAOperationType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMyMPARequestsRequestFilters.attributeTypeMap;
    }
    constructor() {
    }
}
